import { create } from 'zustand'

import { useDynamicManageStore } from './useDynamicManageStore'
import { ERROR_MESSAGE } from 'constants/docUploadConstant'

const initialState = {
    errorMessage: ERROR_MESSAGE,
    handleBack: () => {}
}

export const useErrorStore = create((set) => ({
    ...initialState,
    showError: ({ backToDM }) => {
        let { errorMessage } = initialState
        let handleBack
        if (backToDM) {
            const { onBack } = useDynamicManageStore.getState()
            handleBack = onBack
        }
        set({ errorMessage, handleBack })
    }
}))
